module.exports = "<template> <sio-form-row if.bind=field field.bind=field></sio-form-row> </template> ";